import { PillColor } from "../components/Pill/Pill";

export type SALE_STATUS =
  | "ORDERED_TO_PRODUCENT"
  | "JUST_SIGNED"
  | "ORDERED_TO_INTERNAL_PRODUCTION"
  | "FITTING_ADJUSTMENTS"
  | "HANDED_TO_CUSTOMER";

export function saleStatusToTranslationKey(status: string | undefined): string {
  switch (status) {
    case "ORDERED_TO_PRODUCENT":
      return "sales.status.ordered_to_producent";
    case "JUST_SIGNED":
      return "sales.status.just_signed";
    case "ORDERED_TO_INTERNAL_PRODUCTION":
      return "sales.status.ordered_to_internal_production";
    case "FITTING_ADJUSTMENTS":
      return "sales.status.fitting_adjustments";
    case "HANDED_TO_CUSTOMER":
      return "sales.status.handed_to_customer";
    default:
      return "global.unknown";
  }
}

export function saleStatusToPillColor(status: string | undefined): PillColor {
  switch (status) {
    case "HANDED_TO_CUSTOMER":
      return "green";
    case "ORDERED_TO_PRODUCENT":
    case "ORDERED_TO_INTERNAL_PRODUCTION":
      return "blue";
    case "FITTING_ADJUSTMENTS":
      return "yellow";
    case "JUST_SIGNED":
      return "orange";
    default:
      return "grey";
  }
}

